import { useQueryClient } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { CheckCircle2, Command } from "lucide-react";
import { useEffect } from "react";
import { Button } from "~/components/ui/button";
import { Card, CardContent } from "~/components/ui/card";
import { $completeOnboarding } from "~/lib/onboarding/mutations";

function CompleteScreen() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    const complete = async () => {
      await $completeOnboarding();
      queryClient.invalidateQueries({ queryKey: ["prompt-templates"] });
      queryClient.invalidateQueries({ queryKey: ["dashboard-stats"] });
      queryClient.invalidateQueries({ queryKey: ["userProviders"] });
      queryClient.invalidateQueries({ queryKey: ["user"] });
    };
    complete();

    const timer = setTimeout(() => {
      navigate({ to: "/dashboard" });
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, queryClient]);

  return (
    <div className="flex flex-col items-center text-center">
      <div className="mb-8">
        <div className="mx-auto mb-6 flex size-20 items-center justify-center">
          <CheckCircle2 className="size-20 text-green-500" />
        </div>
        <h1 className="mb-4 text-4xl font-bold tracking-tight">You're all set!</h1>
        <p className="text-muted-foreground text-xl">
          Start chatting with 3 free requests per day.
        </p>
      </div>

      <Card className="mb-8 w-full max-w-md">
        <CardContent>
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3 text-left">
              <div className="bg-muted flex size-10 shrink-0 items-center justify-center rounded-lg">
                <Command className="size-5" />
              </div>
              <div>
                <p className="font-medium">
                  Press{" "}
                  <kbd className="bg-muted rounded px-1.5 py-0.5 font-mono text-sm">
                    ⌘K
                  </kbd>{" "}
                  to open the Command Palette
                </p>
                <p className="text-muted-foreground text-sm">
                  Type "Fix" to use your first template
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      <div>
        <Button size="lg" onClick={() => navigate({ to: "/dashboard" })}>
          Go to Dashboard
        </Button>
        <Button
          variant="outline"
          onClick={() => navigate({ to: "/dashboard/settings/providers" })}
        >
          Add My Own Provider
        </Button>
      </div>

      <p className="text-muted-foreground mt-4 text-sm">
        Redirecting automatically in a few seconds...
      </p>
    </div>
  );
}

export const Route = createFileRoute("/(authenticated)/onboarding/complete")({
  component: CompleteScreen,
});
